export default "__VITE_ASSET__DoadLrLq__"